// @flow
import { RootAction } from "../types";
import { SESSION_USE_EMBEDDED_THEME, SESSION_FETCHED_CURRENT_USER } from "./actions";
import { User } from "./types";

export interface State {
  loading: boolean;
  errorMessage: string | null;
  data: {
    currentUser: User | null;
    isEmbeddedSession: boolean;
  };
}

export const blankState = (): State => ({
  loading: false,
  errorMessage: null,
  data: {
    currentUser: null,
    isEmbeddedSession: false
  }
});

export default function reducer(state: State | undefined, action: RootAction): State {
  if (!state) {
    return reducer(blankState(), action);
  }

  switch (action.type) {
    case "session/fetch-current-user":
      return { ...state, loading: true };

    case "session/destroy-session":
      return blankState();

    case SESSION_FETCHED_CURRENT_USER:
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: { ...state.data, currentUser: action.user }
      };

    case "session/fetch-current-user-error":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };

    case "session/fetch-participant-user":
      return { ...state, loading: true };

    case "session/fetch-participant-user-success":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: { ...state.data, currentUser: action.user }
      };

    case "session/fetch-participant-user-error":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };

    case "session/logout":
      return {
        ...state,
        loading: false,
        errorMessage: null,
        data: { ...state.data, currentUser: null }
      };

    case SESSION_USE_EMBEDDED_THEME:
      return {
        ...state,
        data: { ...state.data, isEmbeddedSession: true }
      };

    default:
      return state;
  }
}
